import ODeleteResource from './o-delete-resource.vue'

export default ODeleteResource
